// @ts-strict-ignore
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { ResumeDatabaseBanner } from 'components/Banners/ResumeDatabaseBanner';
import { SalarySurveyBanner } from 'components/Banners/SalarySurveyBanner';
import { Box } from 'components/Box';
import {
  GradFairsBannerTop,
  bannerIsDismissed as gradFairsBannerisDismissed,
} from 'components/GradFairs/GradFairsBannerTop';
import { ClientOnly } from 'containers/ClientOnly';
import { useMainSelector } from 'store/main';
import { setAdTypeOnPageLoad } from 'store/main/ducks/layout';
import { configValue } from 'utils/config';
import { isLoggedIn, isNonAdmin } from 'utils/currentUser';
import { promoteResumeDatabase } from 'utils/resumeDatabase';
import { promoteSalarySurvey } from 'utils/salarySurvey';

export function BannerAds() {
  const { currentUser, adTypeOnPageLoad, hideSalarySurveyAd } = useMainSelector(
    (state) => ({
      adTypeOnPageLoad: state.layout.adTypeOnPageLoad,
      hideSalarySurveyAd: state.layout.hideSalarySurveyAd,
      currentUser: state.currentUser,
    })
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const hasGradFairsBanner =
    !gradFairsBannerisDismissed() &&
    (!isLoggedIn(currentUser) || isNonAdmin(currentUser)) &&
    configValue('idealist', 'fairsAds') &&
    currentUser.isLoaded &&
    CURRENT_LOCALE === 'en';

  useEffect(() => {
    if (
      currentUser.isLoaded &&
      adTypeOnPageLoad !== 'GRAD_FAIRS' &&
      hasGradFairsBanner
    ) {
      dispatch(setAdTypeOnPageLoad('GRAD_FAIRS'));
    }
  }, [currentUser.isLoaded, adTypeOnPageLoad, hasGradFairsBanner, dispatch]);

  const hasSalarySurveyBanner =
    !hasGradFairsBanner &&
    !['GRAD_FAIRS'].includes(adTypeOnPageLoad) &&
    !history.location.pathname.includes('/survey') &&
    !hideSalarySurveyAd &&
    promoteSalarySurvey({
      // @ts-expect-error fix me
      currentUser,
      allowDismissal: true,
    });

  useEffect(() => {
    if (
      currentUser.isLoaded &&
      adTypeOnPageLoad !== 'SALARY_SURVEY' &&
      hasSalarySurveyBanner
    ) {
      dispatch(setAdTypeOnPageLoad('SALARY_SURVEY'));
    }
  }, [currentUser.isLoaded, dispatch, adTypeOnPageLoad, hasSalarySurveyBanner]);

  const hasResumeDatabaseBanner =
    !hasGradFairsBanner &&
    !hasSalarySurveyBanner &&
    !['GRAD_FAIRS', 'SALARY_SURVEY'].includes(adTypeOnPageLoad) &&
    promoteResumeDatabase({
      // @ts-expect-error fix me
      currentUser,
      allowLoggedOut: true,
    });

  useEffect(() => {
    if (
      currentUser.isLoaded &&
      adTypeOnPageLoad !== 'RESUME_DB' &&
      hasResumeDatabaseBanner
    ) {
      dispatch(setAdTypeOnPageLoad('RESUME_DB'));
    }
  }, [
    currentUser.isLoaded,
    adTypeOnPageLoad,
    hasResumeDatabaseBanner,
    dispatch,
  ]);

  return (
    <Box
      data-qa-id="ads-container"
      mt={[60, null, null, 0]}
      mb={[-60, null, null, 0]}
    >
      <ClientOnly>
        {hasGradFairsBanner && <GradFairsBannerTop />}
        {hasResumeDatabaseBanner && (
          // @ts-expect-error fix me
          <ResumeDatabaseBanner currentUser={currentUser} />
        )}
        {hasSalarySurveyBanner && <SalarySurveyBanner />}
      </ClientOnly>
    </Box>
  );
}
